import React, {useState, useEffect} from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import {EditOutlined, SearchOutlined, DeleteOutlined} from '@ant-design/icons'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import BrokerForm from './AddEditAssignBroker'
import {toast} from 'react-toastify'
import CommonSearch from '../../hooks/Search'

const AssignBrokerList = () => {
  const [search, setSearch] = useState('')
  const [masterBrokerBrokers, setMasterBrokerBrokers] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedID, setSelectedID] = useState(null)
  const [selectedMasterBrokerID, setSelectedMasterBrokerID] = useState()
  const [selectedBrokerID, setSelectedBrokerID] = useState()

  const fetchAllMasterBrokers = async () => {
    const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/masterbroker`
    const res = await apiRequest(url, 'GET')
    return res?.success ? res.data : []
  }

  useEffect(() => {
    fetchAssignedMasterBrokers()
    console.log('modalVisible changed:', modalVisible)
  }, [modalVisible])

  const fetchMasterBroker = async () => {
    const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/masterbroker`
    const res = await apiRequest(url, 'GET')
    return res?.data || []
  }

  const fetchAssignedMasterBrokers = async () => {
    setLoading(true)
    try {
      const loggedInUserId = localStorage.getItem('loggedInUserID')
      const roles = JSON.parse(localStorage.getItem('roles') || '[]')
      const isSuperAdmin = roles.includes('SuperAdmin')

      if (isSuperAdmin) {

        const MasterBrokerList = await fetchMasterBroker()
        const masterBrokerIds = MasterBrokerList.map(mb => mb.id)
        const brokers = await fetchRelations(masterBrokerIds)
        setMasterBrokerBrokers(brokers)
      } else {
        // Regular user (MasterBroker): fetch brokers under them
        let userIdStr = [loggedInUserId]
        const underwriters = await fetchRelations(userIdStr)
        const underwriterIds = underwriters.map(item => item.assigneeId)
        const masterBrokers = await fetchRelations(underwriterIds)
        const masterBrokerIds = masterBrokers.map(item => item.assigneeId)
        const brokers = await fetchRelations(masterBrokerIds)
        setMasterBrokerBrokers(brokers)
      }
    } catch (error) {
      console.error('Error fetching broker assignments:', error)
      toast.error('Something went wrong')
    } finally {
      setLoading(false)
    }
  }

  const fetchAllInsurers = async () => {
    const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/insurer`
    const res = await apiRequest(url, 'GET')
    return res?.data || []
  }

  const fetchRelations = async payload => {
    const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetUserRelationship`
    const res = await apiRequest(url, 'POST', payload)
    return res?.success ? res.data : []
  }

  const handleCreate = () => {
    setSelectedID(0)
    setSelectedMasterBrokerID(0)
    setSelectedBrokerID(0)
    setModalVisible(true)
  }

  const handleEdit = recordId => {
    const record = masterBrokerBrokers.find(({id}) => id === recordId)
    if (record) {
      const {assignorId, assigneeId, id} = record
      setSelectedMasterBrokerID(assignorId)
      setSelectedBrokerID(assigneeId)
      setSelectedID(id)
      setModalVisible(true)
    }
  }

  const handleDelete = async (recordId, assigneeId) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/DeleteSubordinate/${recordId}/${assigneeId}`,
        'GET',
      )
      if (response.data.success) {
        toast.success('Broker assignment deleted successfully')
        await fetchAssignedMasterBrokers()
      } else {
        toast.error(
          response.data.message || 'Failed to delete broker assignment',
        )
      }
    } catch (error) {
      console.error('Error deleting broker assignment:', error)
      toast.error('Error deleting broker assignment')
    }
  }

  const handleModalClose = async () => {
    setModalVisible(false)
    await fetchAssignedMasterBrokers() // force refresh after modal closes
  }

  const columns = [
    {
      title: 'Master Broker',
      key: 'masterBrokerName',
      render: (_, record) => record?.assignorName || 'N/A',
    },
    {
      title: 'Broker',
      key: 'brokerName',
      render: (_, record) => record?.assigneeName || 'N/A',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit Assignment">
            <Button type="primary" onClick={() => handleEdit(record.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this claim limit?"
            onConfirm={() => handleDelete(record.id, record.assigneeId)}
            okText="Yes"
            cancelText="No">
            <Tooltip title="Delete">
              <Button type="danger" style={{marginLeft: 8}}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]
  const handleSearch = value => {
    const filterTable = masterBrokerBrokers.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setMasterBrokerBrokers(filterTable)
  }
  const ClearSerach = () => {
    setSearch('')
    setMasterBrokerBrokers(masterBrokerBrokers)
    fetchAssignedMasterBrokers()
  }
  return (
    <div title="Assign Broker" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: '##f15a2b',
                  fontWeight: '600',
                  fontSize: '20px',
                }}>
                Assign Broker / FinanceUser to Master Broker
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <CommonSearch
              value={search}
              onChange={e => setSearch(e.target.value)}
              onSearch={handleSearch}
              onClear={ClearSerach}
            />
          </Col>
          <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={() => handleSearch(search)}
                style={{marginLeft: 10}}>
                Search
              </Button>
            </div>
          </Col>
          <Col xs={14} sm={14} md={6} lg={5} xl={4}>
            <div className="create-quotation">
              <Button type="primary" onClick={handleCreate}>
                Assign Broker
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin size="large" style={{display: 'block', marginTop: 20}} />
      ) : (
        <Table columns={columns} dataSource={masterBrokerBrokers} rowKey="id" />
      )}

      <Modal
        title={selectedID ? 'Edit Broker Assignment' : 'Assign Broker'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <BrokerForm
          MasterBrokerID={selectedMasterBrokerID}
          BrokerID={selectedBrokerID}
          recordID={selectedID}
          onSuccess={handleModalClose}
          modalVisible={modalVisible}
        />
      </Modal>
    </div>
  )
}

export default AssignBrokerList
